import { RouteGroupActiveOutputData } from './route-group-active-output-data.model';


export class RouteSelectActiveOutput implements IRouteSelectActiveOutput {
    status!: number;
    message!: string;
    data!: RouteGroupActiveOutputData[];

    constructor(data?: IRouteSelectActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RouteGroupActiveOutputData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RouteSelectActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RouteSelectActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRouteSelectActiveOutput {
    status: number;
    message: string;
    data: RouteGroupActiveOutputData[];
}

